import { actions } from '../index';
import { getRequiredSessionToken } from '../../utils/session-token';

import createRxStore, { ofType } from '..';

import { SenseiApi } from '../../utils/api';
import { Toaster } from '@densityco/ui';

import { RenderedTimelineEvent } from '../../components/CaptureViewer/ViewerPlaybackControls';
import {
  EventTimelineState,
  EventTimelineAction,
  EventTimelineActionTypes,
  RenderedTimelineEventWithTrackOffset,
} from '../../types/event-timeline';

function convertFromTimelineEvent(
  input: Array<RenderedTimelineEventWithTrackOffset>,
): Array<any> {
  return input.map((i) => ({
    ...i,
    seconds_offset: i.secondsOffset,
    is_dupe: !i.filled,
    x_position: i.x,
    y_position: i.y,
  }));
}

export const initialState: EventTimelineState = {
  pendingChanges: [],
};

function reducer(
  state: EventTimelineState,
  action: EventTimelineAction,
): EventTimelineState {
  switch (action.type) {
    case EventTimelineActionTypes.EVENT_TIMELINE_ADD_CHANGE:
      let newPendingChanges;
      // if this event is already change list, delete the existing change
      // and add the new one instead (no double changes)
      const existingIndex = state.pendingChanges
        .map((i) => i.id)
        .indexOf(action.change.id);
      if (existingIndex === -1) {
        newPendingChanges = state.pendingChanges.concat(action.change);
      } else {
        if (state.pendingChanges.length === 1) {
          newPendingChanges = [action.change];
        } else {
          newPendingChanges = state.pendingChanges
            .slice(0, existingIndex)
            .concat(state.pendingChanges.slice(existingIndex + 1))
            .concat(action.change);
        }
      }
      return {
        ...state,
        pendingChanges: newPendingChanges,
      };
    case EventTimelineActionTypes.EVENT_TIMELINE_CLEAR_CHANGES:
      return {
        ...state,
        pendingChanges: [],
      };
    default:
      return state;
  }
}

const MPIEventTimelineStore = createRxStore(
  'MPIEventTimelineStore',
  initialState,
  reducer,
);

function updateAnnotationEvents(jwtToken, annotations): Array<Response> {
  return annotations.map(async (annotation) => {
    try {
      return await SenseiApi.updateCaptureAnnotation(jwtToken, annotation);
    } catch (error) {
      console.log(error);
    }
  });
}

//=================================
//SIDE EFFECT: update the annotation event
//=================================
actions
  .pipe(
    ofType(EventTimelineActionTypes.EVENT_TIMELINE_UPDATE_ANNOTATION_EVENTS),
  )
  .subscribe((action) => {
    const jwtToken = getRequiredSessionToken();
    const a = action as any;

    const changes = convertFromTimelineEvent(a.changes);

    const results = updateAnnotationEvents(jwtToken, changes);

    // The promise type in ts 3.6 doesn't support allSettled
    // remove the cast when ts is upgraded to 3.8+
    (Promise as any).allSettled(results).then((responses) => {
      if (responses.every((response) => response.value.ok)) {
        Toaster.showToast({
          text: `${responses.length} annotation${
            responses.length > 1 ? 's' : ''
          } updated.`,
        });
      } else {
        const numSuccesses = responses.reduce(
          (sum: number, current: Response) => (current.ok ? sum + 1 : sum),
          0,
        );
        const numFailures = responses.length - numSuccesses;
        Toaster.showToast({
          text: `${numSuccesses} annotation${
            numSuccesses > 1 ? 's' : ''
          } updated.`,
        });
        Toaster.showToast({
          text: `Error updating ${numFailures} annotation${
            numFailures > 1 ? 's' : ''
          }.`,
          type: 'error',
        });
      }
    });

    window.setTimeout(() => window.location.reload(), 1500);
  });

export default MPIEventTimelineStore;
